import { render, staticRenderFns } from "./StockCompare.vue?vue&type=template&id=3b3a2160&"
import script from "./StockCompare.vue?vue&type=script&lang=js&"
export * from "./StockCompare.vue?vue&type=script&lang=js&"
import style0 from "./StockCompare.vue?vue&type=style&index=0&id=3b3a2160&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports